import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { GuideRoutes } from './main/GuideRoutes';
import { useTranslation } from 'react-i18next';

export const Guides = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Training')} />
      <PageTemplate main={<GuideRoutes />} />
    </>
  );
};
